import * as React from "react";
import {
    Button,
    Col,
    OverlayTrigger,
    Row,
    Tooltip as BootstrapTooltip,
} from "react-bootstrap";
import { Icon, IconsList } from "./icons";
import * as rootStyles from "../../styles";
import { SmallSolidButton } from ".";
import { isMobile, isTablet } from "react-device-detect";
import { glass } from "../../styles";

export type TooltipProps = {
    icon: any;
    message: string;
    buttonText?: string;
    buttonAction?: any;
    placement?: rootStyles.popupStyles.tooltipPlacement;
    id: string;
};

export const Tooltip: React.FC<TooltipProps> = ({
    icon,
    message,
    buttonText,
    buttonAction,
    placement = "top",
    id,
}) => {
    const [show, setShow] = React.useState(false);
    const hideTimeout = React.useRef<number>();
    const isMobileOrTablet = isMobile || isTablet;

    const handleToggle = (nextShow: boolean) => {
        clearTimeout(hideTimeout.current);
        if (nextShow) {
            setShow(true);
        } else if (isMobileOrTablet) {
            setShow(false);
        } else {
            hideTimeout.current = window.setTimeout(() => setShow(false), 300);
        }
    };

    const renderTooltip = (props: any) => (
        <rootStyles.popupStyles.StyledTooltip
            {...props}
            onMouseEnter={() => clearTimeout(hideTimeout.current)}
            onMouseLeave={() => handleToggle(false)}
        >
            <Row style={{ justifyContent: "flex-end", marginBottom: rootStyles.spacers.micro }}>
                <Icon
                    size={12}
                    icon={IconsList.action_cancel}
                    id={`${id}_TooltipDismiss`}
                    iconDescription="Dismiss tooltip"
                    onClick={() => setShow(false)}
                    style={{ cursor: "pointer" }}
                />
            </Row>
            <Row>
                <span style={rootStyles.textStyles.primary}>{message}</span>
            </Row>
            {buttonText ? (
                <Row>
                    <Col
                        style={{
                            padding: 0,
                            marginTop: rootStyles.spacers.small,
                        }}
                    >
                        <SmallSolidButton
                            onClick={buttonAction ? buttonAction : () => null}
                            title={buttonText}
                            containerStyle={{ width: "100%" }}
                            id={`${props.id}_ActionButton`}
                        />
                    </Col>
                </Row>
            ) : null}
        </rootStyles.popupStyles.StyledTooltip>
    );

    return (
        <OverlayTrigger
            placement={placement}
            overlay={renderTooltip(placement)}
            trigger={isMobileOrTablet ? "click" : ["hover", "focus"]}
            show={show}
            onToggle={handleToggle}
            rootClose
        >
            <Button
                style={{
                    background: "none",
                    padding: 0,
                    border: "none",
                    opacity: 1,
                    display: "flex",
                }}
            >
                <Icon
                    size={16}
                    icon={icon}
                    style={{ opacity: glass._4 }}
                    id={`${id}_TooltipButton`}
                />
            </Button>
        </OverlayTrigger>
    );
};

export default Tooltip;
